export const PrivacySection1 = () => {
  return (
    <>
      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            Welcome to WinGrow ("we," "our," or "us"). We are committed to protecting your privacy
            and personal information. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you use our lead management platform and services
            (the "Service").
          </p>
          <p>
            By using WinGrow, you agree to the collection and use of information in accordance with
            this Privacy Policy. If you do not agree with our policies and practices, please do not
            use our Service.
          </p>
          <p>
            This policy applies to all users of WinGrow, including those who connect their Facebook,
            Instagram, and WhatsApp Business accounts to our platform.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>We collect several types of information to provide and improve our Service:</p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.1 Account Information</h3>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Name and email address (when you create an account or sign in with Facebook)</li>
            <li>Password (if you create an account directly with WinGrow)</li>
            <li>Profile picture (if provided through Facebook login)</li>
            <li>Business name and industry information</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.2 Communication Data</h3>
          <ul className="ml-6 space-y-2 list-disc">
            <li>WhatsApp Business messages and conversations with your leads</li>
            <li>Facebook Messenger conversations with your leads</li>
            <li>Instagram Direct messages with your leads</li>
            <li>Message timestamps and metadata</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            2.3 Lead Contact Information
          </h3>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Lead names, phone numbers, and email addresses</li>
            <li>Conversation history with leads</li>
            <li>Lead engagement metrics and status</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            2.4 Analytics and Insights
          </h3>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Facebook Page analytics and insights</li>
            <li>Instagram Business Account analytics</li>
            <li>WhatsApp Business Account metrics</li>
            <li>Engagement statistics and performance data</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.5 Usage Data</h3>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Device information (browser type, operating system)</li>
            <li>IP address and approximate location</li>
            <li>Pages visited and features used</li>
            <li>Time spent on the platform</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            2.6 Cookies and Tracking Technologies
          </h3>
          <p>
            We use cookies and similar tracking technologies to track activity on our Service and
            hold certain information. For more details, please see our{' '}
            <a href="/cookies" className="text-blue-600 underline hover:text-blue-800">
              Cookies Policy
            </a>
            .
          </p>
        </div>
      </section>
    </>
  );
};
